import api from '../../services/api';

// Get dashboard overview analytics
export const getDashboardAnalytics = async () => {
    try {
        const response = await api.get('/admin/analytics/overview');
        return response.data;
    } catch (error) {
        console.error('Error fetching dashboard analytics:', error);
        throw error;
    }
};

// Get user growth data
export const getUserGrowth = async (period = '30d') => {
    try {
        const response = await api.get(`/admin/analytics/users?period=${period}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching user growth:', error);
        throw error;
    }
};

// Get engagement metrics
export const getEngagementMetrics = async () => {
    try {
        const response = await api.get('/admin/analytics/engagement');
        return response.data;
    } catch (error) {
        console.error('Error fetching engagement metrics:', error);
        throw error;
    }
};

// Get geographic distribution
export const getGeographicDistribution = async () => {
    try {
        const response = await api.get('/admin/analytics/geographic');
        return response.data;
    } catch (error) {
        console.error('Error fetching geographic distribution:', error);
        throw error;
    }
};

// Get recent activities
export const getRecentActivities = async (limit = 10) => {
    try {
        const response = await api.get(`/admin/analytics/activities?limit=${limit}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching recent activities:', error);
        throw error;
    }
};

// Get system health status
export const getSystemHealth = async () => {
    try {
        const response = await api.get('/admin/system/health');
        return response.data;
    } catch (error) {
        console.error('Error fetching system health:', error);
        throw error;
    }
};

// Get LMS course progress for all users
export const getLMSProgressTracking = async () => {
    try {
        const response = await api.get('/admin/lms/users-progress');
        return response.data;
    } catch (error) {
        console.error('Error fetching LMS progress tracking:', error);
        throw error;
    }
};

export default {
    getDashboardAnalytics,
    getUserGrowth,
    getEngagementMetrics,
    getGeographicDistribution,
    getRecentActivities,
    getSystemHealth,
    getLMSProgressTracking,
};
